import { useQuery } from '@tanstack/react-query';
import { getCounterpartiesAvailability } from '@/services/counterparties';
import { COUNTERPARTIES_AVAILABILITY_QUERY_KEY } from '@/constants/react_query_keys';

// Whether the company keeps its books in the ledger, which the Suppliers section reads from.
export function useGetCounterpartiesAvailability({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [COUNTERPARTIES_AVAILABILITY_QUERY_KEY],
    queryFn: () => getCounterpartiesAvailability(),
    staleTime: Infinity,
    retry: false,
    enabled
  });
}
